import React from 'react';

type Props = {
  onClick?: (env: React.MouseEvent<HTMLImageElement>) => void;
};

const ThemeSwitcher: React.FC<Props> = (props) => {
  const onClick = (event: React.MouseEvent<HTMLImageElement>) => {
    if (props.onClick) {
      props.onClick(event);
    }
  };

  return (
    <img
      className="icon-theme-switcher mr-4"
      alt="Toggle theme"
      onClick={onClick}
    />
  );
};

export default ThemeSwitcher;
